<template>
  <div class="lesson-entity">
    <slot name="header"></slot>
    <component :is="targetType" ref="entity" :entity="targetModel" v-if="targetModel" :config="entity.entity_data"
               :theme="theme"></component>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import kewen from './../../kewen/KewenPreview'
import kwparg from './../../kewen/KewenParagraphPreview'
import word from './../../word/WordPreview'
import grammar from './../../grammar/GrammarPreview'
import graphic from './../../graphic/GraphicPreview'
import exercise from './../../exercise/ExercisePreview'
import titlepage from './TitlePagePreview'
import sentence from '@/views/sentence/SentencePreview';
import ai_kewen from "@/components/lesson/units/ai/ai_kewen.vue";
import ai_words from "@/components/lesson/units/ai/ai_words.vue";
import ai_rc from "@/components/lesson/units/ai/ai_rc.vue";
import ai_qa from "@/components/lesson/units/ai/ai_qa.vue";
import ai_topic from "@/components/lesson/units/ai/ai_topic.vue";
import ai_rpg from "@/components/lesson/units/ai/ai_rpg.vue";
import ai_word_trans from "@/components/lesson/units/ai/ai_word_trans.vue";
import ai_word_sentence from "@/components/lesson/units/ai/ai_word_sentence.vue";
import ai_sentence_order from "@/components/lesson/units/ai/ai_sentence_order.vue";
import ai_sentence_trans from "@/components/lesson/units/ai/ai_sentence_trans.vue";

export default {
  name: 'LessonEntity',
  props: {
    entity: Object,
    theme: {
      type: String,
      default: 'card'
    }
  },
  components: {kewen, word, grammar, exercise, kwparg, titlepage, graphic, sentence, ai_kewen, ai_words, ai_rc, ai_qa, ai_topic, ai_rpg, ai_word_trans, ai_word_sentence, ai_sentence_order, ai_sentence_trans},
  data() {
    return {}
  },
  computed: {
    isTitlePage() {
      return /^fy_|^iq_|^ct$/i.test(this.entity.entity_type)
    },
    targetType() {
      return this.isTitlePage ? 'titlepage' : this.entity.entity_type.replace(/^industry_/, '')
    },
    targetModel() {
      if (this.isTitlePage) {
        return {
          id: 0,
          type: this.entity.entity_type,
          entity_id: this.entity.entity_id,
          ...this.entity.entity_data,
        }
      }
      if (/^ai_/.test(this.entity.entity_type)) {
        return this.entity;
      }
      let attr = this.entity.entity_type + '_entity'
      return this.entity[attr]
    }
  }
}
</script>

<style lang="scss">
.lesson-entity {
  position: relative;
  min-height: 25px;
}
</style>
